import ConfirmModal, { CONFIRM_MODAL_TYPE } from 'component/Modal/ConfirmModal'
import { useCallback, useRef } from 'react'
import useHintModal from './useHintModal'

interface OpenConfirmOptions {
  title?: string
  message?: string
  onConfirm?: () => void
  onCancel?: () => void
  type?: number
  confirmText?: string
  cancelText?: string
}

export default function useConfirmModal() {
  const { openHintModal, closeHintModal } = useHintModal()

  const currentCancel = useRef<(() => void) | undefined>()
  const currentConfirm = useRef<(() => void) | undefined>()

  const onCancelProxy = useCallback(() => {
    closeHintModal()
    currentCancel.current?.()
  }, [closeHintModal])

  const onConfirmProxy = useCallback(() => {
    closeHintModal()
    currentConfirm.current?.()
  }, [closeHintModal])

  const openConfirm = useCallback(
    ({
      title,
      message,
      onConfirm,
      onCancel,
      type = CONFIRM_MODAL_TYPE.OK_CANCEL,
      confirmText,
      cancelText,
    }: OpenConfirmOptions) => {
      currentCancel.current = onCancel
      currentConfirm.current = onConfirm
      openHintModal({
        children: ConfirmModal,
        props: {
          title,
          message,
          onConfirm: onConfirmProxy,
          onCancel: onCancelProxy,
          type: type,
          confirmText,
          cancelText,
        },
      })
    },
    [onCancelProxy, onConfirmProxy, openHintModal]
  )

  const formatApiErrorMessage = useCallback((error: any): string => {
    if (error?.response?.status === 503 || error?.code === 503) {
      return '当前线路不稳，载入失败'
    }
    return error?.message || '发生错误'
  }, [])

  const formatGameLobbyApiErrorButtonText = useCallback((error: any): string => {
    if (error?.response?.status === 503 || error?.code === 503) {
      return '切换线路'
    }
    return '重试'
  }, [])

  return { openConfirm, formatApiErrorMessage, formatGameLobbyApiErrorButtonText }
}
